import { IMonthsOfTheYear } from './flow';
import { getAxios } from 'hooks/useAxios';
import { ENDPOINTS } from 'services/endpoints';

const api = getAxios();

export interface IRequestGetNisaParams {
	company_id?: string;
	department?: string;
	year?: number;
}

export interface IResponseNisaParameters {
	id?: string;
	company_id?: string;
	department?: string;
	year?: number;
	// fluxoLojaPassante: IMonthsOfTheYear;
	// fluxoLigacoes: IMonthsOfTheYear;
	comparecimentoLigacoes: IMonthsOfTheYear;
	// fluxoLojaVendedor: IMonthsOfTheYear;
	// ligacoesRecebidas: IMonthsOfTheYear;
	comparecimento: IMonthsOfTheYear;
	conversao: IMonthsOfTheYear;
	// totalSales: IMonthsOfTheYear;
	billings: IMonthsOfTheYear;
	averageTicket: IMonthsOfTheYear;
	complimentaryExpenses: IMonthsOfTheYear;
	percentageMb: IMonthsOfTheYear;
	financing: IMonthsOfTheYear;
	financingContracts: IMonthsOfTheYear;
	financingPenetration: IMonthsOfTheYear;
	financingEvasion: IMonthsOfTheYear;
	financingValuePenetration: IMonthsOfTheYear;
	carReturn: IMonthsOfTheYear;
	financingProfitability: IMonthsOfTheYear;
	tccb: IMonthsOfTheYear;
	tccbByContract: IMonthsOfTheYear;
	// tccbByCar: IMonthsOfTheYear;
	placement: IMonthsOfTheYear;
	placementByCar: IMonthsOfTheYear;
	capture: IMonthsOfTheYear;
	evaluation: IMonthsOfTheYear;
	txEvaluation: IMonthsOfTheYear;
	txBuy: IMonthsOfTheYear;
	txCapture: IMonthsOfTheYear;
	contributionMargin: IMonthsOfTheYear;
	totalGrossProfit: IMonthsOfTheYear;
	grossProfitwithoutRevenue: IMonthsOfTheYear;
	accessories: IMonthsOfTheYear;
	mediumAccessoryTicket: IMonthsOfTheYear;
	hgsi: IMonthsOfTheYear;
	nps: IMonthsOfTheYear;
	oficina: IMonthsOfTheYear;
	// leads: IMonthsOfTheYear;
}

export const getAllNisaParameters = async (params?: IRequestGetNisaParams): Promise<IResponseNisaParameters[]> => {
	const response = await api.get(ENDPOINTS.getAllNisaParameters, { params });
	return response.data;
};

export const createNisaParameters = async (data: IResponseNisaParameters): Promise<void> => {
	const response = await api.post(ENDPOINTS.createNisaParameters, data);
	return response.data;
};

export const editNisaParameters = async (data: IResponseNisaParameters, nisaId: string) => {
	const response = await api.put<IResponseNisaParameters>(ENDPOINTS.editNisaParameters(nisaId), data);
	return response?.data;
};

export const editPatchNisaParameters = async (data: Partial<IResponseNisaParameters>, nisaId: string) => {
	const response = await api.patch<IResponseNisaParameters>(ENDPOINTS.editNisaParameters(nisaId), data);
	return response?.data;
};

export const deleteNisaParameters = async (nisaId: string): Promise<void> => {
	return api.delete(ENDPOINTS.deleteNisaParameters(nisaId));
};
